import React, { Component } from 'react'
import { Popover, Modal, Input, Button, Upload, Icon } from 'antd'
import { app, api, config } from '../../../../app'

import html2canvas from 'html2canvas';



class BrandConfirmation extends Component {
    // 组件内部
    constructor(props) {
        super(props)
        let whiteInfo = {          //注册表内容
            d1: '',
            d2: '',
            d3: '',
            d4: '',
            d5: '',
            d6: '',
        }
        let uploadImgList = []
        let whiteOK = false
        if(props.fileInfo.length <= 0){

        }else if(props.fileInfo[1].data != undefined){
            if (props.fileInfo[1].data.d1 != undefined) {
                whiteInfo = props.fileInfo[1].data
                whiteOK = true
                this.props.brand_file_json(whiteInfo, 'data')
    
                if (props.fileInfo[1].img != undefined && props.fileInfo[1].img != '') {
                    uploadImgList = props.fileInfo[1].img.split(';;;')
                    this.props.brand_file_json(uploadImgList, 'img')
    
                }
            }
        } 
        

        if (props.com3.data != undefined) {
            whiteInfo = props.com3.data
            if (props.com3.img != '') {
                uploadImgList = props.com3.img.split(';;;')
            }
        }

        this.state = {
            fileInfo: props.fileInfo,
            defaultImgList: [],

            brandConfirmation: false,   //是否打开 品牌确认书 格式预览弹窗

            // 第一个信息表弹窗
            whiteInfo: whiteInfo,


            uploadImgList: uploadImgList,
            imgModal: false,
            showMoadlImg: '',
            whiteOK: whiteOK,  //是否已经提交过内容,
            whiteModal: false



        }

    }

    componentDidMount() {
        this.getDefaultImg()
        this.getExamineInfo()
        this.getApplyinfo()
    }


    componentWillReceiveProps(nextProps) {
        if (nextProps.applyinfo !== this.props.applyinfo) {
            if (this.props.apply != 1) {
                return
            }
            // 值发生改变下一步工作
            const applyinfo = app.getData('applyinfo');
            this.props.brand_file_json(applyinfo.file[1].data, 'data')

            let uploadImgList = applyinfo.file[1].img.split(';;;')
            this.props.brand_file_json(uploadImgList, 'img')

            this.setState({
                uploadImgList,
                whiteInfo: applyinfo.file[1].data,
                whiteOK: true
            })
        }
        if (nextProps.examineInfo !== this.props.examineInfo) {
            // 值发生改变下一步工作
            if (this.props.examine != 1) {
                return
            }
            const examineInfo = app.getData('examineInfo');
            let uploadImgList = this.state.uploadImgList;
            uploadImgList = examineInfo.file[1].img.split(';;;')
            this.setState({
                uploadImgList
            })
        }
    }

    //对默认展示图片进行处理
    getDefaultImg = () => {
        if(this.props.fileInfo.length <=0){
            return
        }
        let defaultImgList = this.props.fileInfo[1].template_img.split(';;;')
        // console.log(defaultImgList)
        this.setState({
            defaultImgList
        })
    }

    getExamineInfo = () => {
        if (this.props.examine != 1) {
            return
        }
        const examineInfo = this.props.examineInfo;
        let uploadImgList = this.state.uploadImgList;
        uploadImgList = examineInfo.file[1].img.split(';;;')
        this.setState({
            uploadImgList
        })
    }

    getApplyinfo = () => {
        if (this.props.apply != 1) {
            return
        }
        const applyinfo = this.props.applyinfo;
        this.props.brand_file_json(applyinfo.file[1].data, 'data')

        let uploadImgList = applyinfo.file[1].img.split(';;;')
        this.props.brand_file_json(uploadImgList, 'img')

        this.setState({
            uploadImgList,
            whiteInfo: applyinfo.file[1].data,
            whiteOK: true
        })
    }

    // {/* 品牌确认数(筹) */}
    showModal2 = () => {
        this.setState({
            brandConfirmation: true
        })
    };


    handleCancel2 = () => {
        // console.log("点击取消");
        this.setState({
            brandConfirmation: false
        })
    };




    // 下载
    downLoad = (blobUrl) => {
        let that = this;
        let xhr = new XMLHttpRequest()
        xhr.open('POST', config.serverUrl + '/TeamPrep/getFilePdf', true)
        xhr.responseType = 'blob'
        let fd = new FormData();
        fd.append("key", 'brand');
        fd.append("file_data", JSON.stringify(this.state.whiteInfo));
        xhr.send(fd);
        xhr.onload = function () {
            if (this.status == 200) {
                let blob = this.response
                console.log(blob)
                that.downloadFile1(blob, 'pdf', '品牌确认书(筹).pdf');
            }
        }
    }

    downloadFile1(data, type, fileName) {
        let blob = new Blob([data], { type: `application/${type};charset=utf-8` });
        console.log(123)
        // 获取heads中的filename文件名
        let downloadElement = document.createElement('a');
        // 创建下载的链接
        let href = window.URL.createObjectURL(blob);
        downloadElement.href = href;
        // 下载后文件名
        downloadElement.download = fileName;
        document.body.appendChild(downloadElement);
        // 点击下载
        downloadElement.click();
        // 下载完成移除元素
        document.body.removeChild(downloadElement);
        // 释放掉blob对象
        window.URL.revokeObjectURL(href);
    }


    downloadJPG = async (DOMId, fileName) => {
        let ppg = document.getElementById(DOMId);

        html2canvas(ppg, {
            allowTaint: false,
            useCORS: true,
        }).then(canvas => {
            // toImage
            const dataImg = new Image()
            dataImg.src = canvas.toDataURL('image/png')
            const alink = document.createElement("a");
            alink.href = dataImg.src;
            alink.download = fileName + ".png";
            alink.click();
            this.setState({
                whiteModal: false
            })
        });
    }




    _changeValue = (e) => {
        const { whiteInfo } = this.state;
        whiteInfo[e.target.name] = e.target.value.trim();
        this.setState({
            whiteInfo
        })
    }



    // 信息表确认提交
    upload = () => {
        const { whiteInfo } = this.state;

        whiteInfo.d6 = whiteInfo.d2
        if (whiteInfo.d1 == '') {
            app.alert('申请人未填写', 'error', '45%')
            return
        }

        if (whiteInfo.d2 == '') {
            app.alert('团队名称未填写', 'error', '45%')
            return
        }


        if (whiteInfo.d3 == '') {
            app.alert('申请日期年份未填写', 'error', '45%')
            return
        }

        if (whiteInfo.d4 == '') {
            app.alert('申请日期月份未填写', 'error', '45%')
            return
        }

        if (whiteInfo.d5 == '') {
            app.alert('申请日期未填写', 'error', '45%')
            return
        }

        if (whiteInfo.d6 == '') {
            app.alert('团队名称', 'error', '45%')
            return
        }
        this.props.brand_file_json(whiteInfo, 'data')
        this.setState({
            whiteModal: false,
            whiteOK: true,
        })
    }






    clickImgCencel = () => {
        this.setState({
            imgModal: false
        })
    }


    // 注册申请表弹窗
    white = () => {
        this.setState({
            whiteModal: true
        })
    }

    closeWhite = () => {
        this.setState({
            whiteModal: false
        })
    }




    uploadImg = (info) => {
        if(info.file.status === 'uploading'){
            let flag = true
            this.props.uploadImgLoading(flag)
            return
        }
        if (info.file.status === 'done') {
            const res = info.file.response
            if (res.flag === 1) {
                // console.log(res)
                app.alert(res.msg, 'success', '45%')
                // 将数据返回给父组件


                // let img = res.data.url;
                // this.props.reg_file_json(img, 'img')
                const { uploadImgList } = this.state;
                // console.log(uploadImgList)

                uploadImgList.push(res.data.url)
                // console.log(uploadImgList)
                // 当上传图片完成后将返回的图片放到本地以备用户预览
                this.props.brand_file_json(uploadImgList, 'img')

                this.setState({
                    uploadImgList
                },()=>{
                    let flag = false
                    this.props.uploadImgLoading(flag)
                })
            } else {
                app.alert(res.msg, 'error', '45%')

            }
        }
    }

    // {/* 存心救援队注册申请表 */}
    clickImg = (i) => {
        this.setState({
            imgModal: true,
            showMoadlImg: i.target.getAttribute('data-img')
        })
    };

    deleImg = (i) => {
        const { uploadImgList } = this.state;
        uploadImgList.splice(i, 1)
        // this.props.deleteImg_brand_file_json(i)
        this.props.brand_file_json(uploadImgList, 'img')

        this.setState({
            uploadImgList
        })
    };

    lastImg = () => {
        let showMoadlImg = this.state.showMoadlImg;
        const { uploadImgList, defaultImgList } = this.state;
        let index
        if (uploadImgList.length < 1) {
            //如果用户没有上传图片，那么点击图片预览的是模版图片
            defaultImgList.forEach((i, v) => {
                if (i == showMoadlImg) {
                    if (v == 0) {
                        index = v
                        app.alert("没有更多图片了", 'error', '45%')
                        return
                    } else {
                        index = v
                    }
                }
            })
            if (index == 0) {
                return
            } else {
                showMoadlImg = defaultImgList[index - 1]
                this.setState({
                    showMoadlImg
                })
            }
        } else {
            //如果用户上传了图片，那么点击图片预览的是上传图片
            uploadImgList.forEach((i, v) => {
                if (i == showMoadlImg) {
                    if (v == 0) {
                        index = v
                        app.alert("没有更多图片了", 'error', '45%')
                        return
                    } else {
                        index = v
                    }
                }
            })
            if (index == 0) {
                return
            } else {
                showMoadlImg = uploadImgList[index - 1]
                this.setState({
                    showMoadlImg
                })
            }
        }


    }

    nextImg = () => {
        let showMoadlImg = this.state.showMoadlImg;
        const { uploadImgList, defaultImgList } = this.state;
        let index
        if (uploadImgList.length < 1) {
            defaultImgList.forEach((i, v) => {
                if (i == showMoadlImg) {
                    if (v == 2 || v == defaultImgList.length - 1) {
                        index = v
                        app.alert("没有更多图片了", 'error', '45%')
                        return
                    } else {
                        index = v
                    }
                }
            })
            if (index == 2 || index == defaultImgList.length - 1) {
                return
            } else {
                showMoadlImg = defaultImgList[index + 1]
                this.setState({
                    showMoadlImg
                })
            }
        } else {
            uploadImgList.forEach((i, v) => {
                if (i == showMoadlImg) {
                    if (v == 2 || v == uploadImgList.length - 1) {
                        index = v
                        app.alert("没有更多图片了", 'error', '45%')
                        return
                    } else {
                        index = v
                    }
                }
            })
            if (index == 2 || index == uploadImgList.length - 1) {
                return
            } else {
                showMoadlImg = uploadImgList[index + 1]
                this.setState({
                    showMoadlImg
                })
            }
        }


    }



    // 页面渲染区
    render() {
        let { fileInfo, whiteInfo, defaultImgList, uploadImgList } = this.state
        const content = (
            <div>
                <p>点击可预览模板</p>
            </div>
        )




        const imgList = uploadImgList.map((item, index) => {
            return (
                <Popover key={item} content={
                    <div >
                        <p style={{ marginBottom: 20, cursor: 'pointer' }} onClick={this.clickImg} data-img={item}>预览</p>
                        {
                            this.props.examine == 1 || this.props.detailF == 1 ? '' :
                                <p style={{ cursor: 'pointer' }} onClick={() => this.deleImg(index)}>删除</p>
                        }

                    </div>
                }>

                    <img style={{ width: 90, height: 100, marginRight: 5 }} key={item} src={config.imgUrl + item} alt="" />
                </Popover>

            )
        })

        const defaultImg = defaultImgList.map((item, index) => {
            return (
                <Popover key={item} content={
                    <div >
                        <p style={{ marginBottom: 20, cursor: 'pointer' }} onClick={this.clickImg} data-img={item}>预览模板</p>
                    </div>
                }>
                    <img style={{ width: 90, height: 100, marginRight: 5 }} key={item} src={config.imgUrl + item} alt="" />
                </Popover>

            )
        })

        return (
            <div >




                {/* 品牌确认数(筹) */}
                <div style={{ width: 400, height: 200, borderWidth: 1, borderStyle: 'solid', borderColor: '#000' }}>
                    {/* 标题 */}
                    <p style={{ fontSize: 16, color: '#1890FF', paddingTop: 15, paddingLeft: 10 }}>
                        <Popover content={content}>
                            <span style={{ cursor: 'pointer' }} onClick={this.showModal2}>《品牌确认书(筹)》</span>
                        </Popover>

                        <Modal title="品牌确认书(筹)" visible={this.state.brandConfirmation} width={1200} footer={null} onCancel={this.handleCancel2}>

                            {
                                defaultImgList.map((item, index) => {
                                    return (

                                        <img style={{ width: 1150, marginRight: 5,borderBottom:3,borderBottomStyle:'solid',borderBottomColor:'#ddd' }} key={item} src={config.imgUrl + item} alt="" />

                                    )
                                })
                            }
                        </Modal>
                    </p>
                    {/* 标题end */}





                    {/* 资料框 */}
                    <div style={{ display: 'flex', justifyContent: 'space-around' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-around', width: '80%' }}>

                            <div style={{ cursor: 'pointer', overflowX: 'auto', whiteSpace: 'nowrap', padding: 3 }}>
                                {
                                    uploadImgList.length < 1
                                        ?
                                        defaultImg
                                        :
                                        imgList
                                }

                            </div>


                            <Modal title="品牌确认书(筹)" visible={this.state.imgModal} width={1200} style={{ display: 'flex', justifyContent: 'center' }} footer={null} onCancel={this.clickImgCencel}>
                                <p style={{ display: 'flex', justifyContent: 'space-around', color: '#1890ff', fontWeight: 'bold' }}>
                                    <div style={{ cursor: 'pointer' }} onClick={this.lastImg}>
                                        <Icon type="left" ></Icon> 上一张
                                    </div>
                                    <div style={{ cursor: 'pointer' }} onClick={this.nextImg}>
                                        下一张<Icon type="right" ></Icon>
                                    </div>
                                </p>
                                {

                                    <img src={config.imgUrl + this.state.showMoadlImg} alt="" style={{ width: 1000 }} />
                                }
                            </Modal>


                        </div>
                        {
                            this.props.examine == 1 || this.props.detailF == 1 ? '' : !this.state.whiteOK
                                ?
                                <div >
                                    <div style={{ cursor: 'pointer', color: '#1890FF' }} onClick={this.white}>填写</div>
                                    <div style={{ marginTop: 5 }}>下载</div>
                                    <div style={{ marginTop: 5 }} >上传</div>
                                </div>
                                :
                                <div >
                                    <div style={{ marginTop: 5, cursor: 'pointer', color: '#1890FF' }} onClick={this.white}>编辑</div>
                                    <div style={{ marginTop: 5, cursor: 'pointer', color: '#1890FF' }} onClick={this.downLoad}>
                                        下载
                                        </div>


                                    {uploadImgList.length == 3
                                        ?
                                        <div style={{ marginTop: 5 }} >上传</div>
                                        :
                                        <div style={{ marginTop: 5, cursor: 'pointer', color: '#1890FF' }} >
                                            <Upload
                                                accept='image/jpeg, image/jpg, image/png'
                                                showUploadList={false}
                                                action={config.serverUrl + "/TeamApply/imageUpload"}
                                                name="image"
                                                onChange={this.uploadImg}
                                                style={{ color: '#1890FF' }}>上传</Upload>
                                        </div>}




                                </div>

                        }

                    </div>
                    {/* 资料框 */}


                    <Modal title="品牌确认书(筹)" visible={this.state.whiteModal} width={1200} footer={null} onCancel={this.closeWhite}>
                        <div style={{ width: 1200, display: 'flex' }}>


                            <div style={{ width: 1200, paddingLeft: 40, paddingRight: 40, paddingTop: 80, height: 1300, fontSize: 22 }} id="JPGDOM">
                                <p style={{ textAlign: 'center', fontSize: 34 }}>关于“存心救援”名称、品牌及标识的确认书</p>
                                <p>尊敬的存心救援品牌管理方：</p>
                                <p style={{ textIndent: '2em' }}>我们由<input type="text"
                                    onChange={this._changeValue}
                                    name="d1" value={whiteInfo.d1}
                                    style={{ outline: 'none', textAlign: 'center', border: 0, borderBottom: 1, borderBottomColor: '#000', borderStyle: 'solid' }} />组成“<input type="text"
                                        onChange={this._changeValue}
                                        name="d2" value={whiteInfo.d2}
                                        style={{ outline: 'none', textAlign: 'center', border: 0, borderBottom: 1, borderBottomColor: '#000', borderStyle: 'solid' }} />”致力于发展公益救援事业，特向存心救援品牌管理方申请：自<input type="text"
                                            onChange={this._changeValue}
                                            name="d3" value={whiteInfo.d3}
                                            style={{ outline: 'none', textAlign: 'center', border: 0, borderBottom: 1, borderBottomColor: '#000', borderStyle: 'solid' }} />年<input type="text"
                                                onChange={this._changeValue}
                                                name="d4" value={whiteInfo.d4}
                                                style={{ outline: 'none', textAlign: 'center', border: 0, borderBottom: 1, borderBottomColor: '#000', borderStyle: 'solid' }} />月<input type="text"
                                                    onChange={this._changeValue}
                                                    name="d5" value={whiteInfo.d5}
                                                    style={{ outline: 'none', textAlign: 'center', border: 0, borderBottom: 1, borderBottomColor: '#000', borderStyle: 'solid' }} />日起加入存心救援组织，规范使用“存心救援”的名称、标识及服装服饰，严格执行存心救援的统一品牌与救援体系，积极参与存心救援组织的培训与行动。</p>

                                <p style={{ textIndent: '2em' }}>我们熟知“存心救援队”发起于2007年，自此至今在国内外创立与发展“存心救援”品牌与组织，尤其2010年至今获得国内外官方组织、救援组织的认可与支持，已成为公益领域知名品牌，为民间救援与公益事业的管理与发展树立了榜样和旗帜！</p>

                                <p style={{ textIndent: '2em' }}>存心救援队（筹）执行理事会，我们及队员承诺：严格遵守《存心救援公约》及“存心救援”品牌管理与救援调度制度，严守“存心救援”理念与品牌荣誉，恪守公益救援与人道精神；如若我们本人或<input type="text"
                                    onChange={this._changeValue}
                                    name="d2" value={whiteInfo.d2}
                                    style={{ outline: 'none', textAlign: 'center', border: 0, borderBottom: 1, borderBottomColor: '#000', borderStyle: 'solid' }} />离开或退出“存心救援”组织与体系，将持续保证不在任何单位、场合、活动中使用“存心救援”的名称、标识和／或穿着“存心救援”的服装、服饰，诚信维护“存心救援”品牌。</p>

                                <p style={{ textIndent: '2em' }}>本确认书亦代表承诺与荣誉，祝存心救援队与“存心救援”品牌获得更大发展。</p>

                                <p style={{ textIndent: '2em' }}>此致</p>
                                <p>敬礼！</p>
                                <p style={{ textIndent: '25em' }}>组织名称：
                                <input type="text"
                                        onChange={this._changeValue}
                                        name="d2" value={whiteInfo.d2}
                                        style={{ outline: 'none', textAlign: 'center', border: 0, borderBottom: 1, borderBottomColor: '#000', borderStyle: 'solid' }} />
                                    {/* _________________________ */}
                                </p>

                                <p style={{ textIndent: '25em' }}>理事会／负责人：<span style={{ color: '#ccc', fontSize: 16 }}>签名加盖手指印</span></p>

                                <p style={{ textIndent: '25em' }}>日期：<span style={{ fontSize: 16 }}>________年________月________日</span></p>

                                <p>
                                    注：
                                                        </p>
                                <p>1.本确认书附理事会／负责人身份证件及个人ID属存心救援队员品牌管理体系；</p>
                                <p>2.
                                    <input type="text"
                                        onChange={this._changeValue}
                                        name="d2" value={whiteInfo.d2}
                                        style={{ outline: 'none', textAlign: 'center', border: 0, borderBottom: 1, borderBottomColor: '#000', borderStyle: 'solid' }} />
                                    {/* _________________ */}
                                    取得政府批文、证书与公章五日内报备编入“存心救援队”队伍体系，执行“存心救援”品牌与救援管理体系；</p>
                                <p>3.本确认书及相关证件、批文与证书等作为“存心救援”品牌与组织全球发展之法定档案。</p>
                            </div>


                        </div>
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <Button style={{ width: 200, backgroundColor: '#1890FF', color: '#fff', marginRight: 40 }} onClick={this.upload}>提交</Button>
                            <Button style={{ width: 200 }} onClick={this.closeWhite}>关闭</Button>
                            <div onClick={this.downloadJPG}></div>

                        </div>
                    </Modal>

                </div>
                {/* 品牌确认数(筹)end */}
            </div>
        )
    }
}



export default BrandConfirmation



// WEBPACK FOOTER //
// ./src/routes/teamApplication/PreparatoryTeamApplicationDirectory/UploadInformationModal/BrandConfirmation.jsx